import { DragOverlay, DragOverlayProps } from '@dnd-kit/core';
import { createPortal } from 'react-dom';
import { useMountStatus } from '../../hooks/useMountStatus';

/**
 * DnDOverlay.
 */
export const DnDOverlay = ({ children, ...props }: DragOverlayProps) => {
  const isMounted = useMountStatus();

  if (!isMounted) {
    return null;
  }

  return createPortal(
    <DragOverlay {...props}>{children}</DragOverlay>,
    document.body,
  );
};
